import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClient } from '@core/services/api-client.http.service';
import { AsappServiceUrls, CommonUrls, ConfigurationManagementUrls } from '@core/constants';
import { SiteDetailDto, SiteDto } from '@core/services/dto';
import { SiteConfigDto } from '../dto/site-configuration.dto';
import { SiteApplicationConfigResponse, SiteSecureConfigResponse } from '../dto/reports/site-details-config.dto';

@Injectable({
  providedIn: 'root'
})
export class DashboardApiService {

  constructor(private api: ApiClient) {
  }

  getDefaultLocation(): Observable<SiteDto> {
    return this.api.get<SiteDto>(CommonUrls.site);
  }
  getSiteDetails(): Observable<SiteDetailDto> {
    return this.api.get<SiteDetailDto>(AsappServiceUrls.siteDetails);
  }
  getSiteDetailsFromConfig(): Observable<SiteDetailDto> {
    return this.api.get<SiteDetailDto>(ConfigurationManagementUrls.siteDetails);
  }
  getSiteConfigurationDetails(): Observable<SiteConfigDto> {
    return this.api.get<SiteConfigDto>(ConfigurationManagementUrls.siteConfigurationDetails);
  }

  getSiteSecureConfigurations(): Observable<SiteSecureConfigResponse> {
    return this.api.get<SiteSecureConfigResponse>(ConfigurationManagementUrls.getSiteSecureConfigurationsBySiteId);
  }
  getSiteApplicationConfigurations(): Observable<SiteApplicationConfigResponse> {
    return this.api.get<SiteApplicationConfigResponse>(ConfigurationManagementUrls.getSiteApplicationConfigurationsBySiteId);
  }
}
